<template>
		<div id="app" class="app" ref="app">
			<MainHeader/>

			<main class="site-main">
				<div class="page-home">
					<BlockBanner :data="bannerData"/>
					<PartLoaderBig :data="LoaderBigData"/>
					<PartNoResults :data="DataNoResults"/>
					<PartSelect :data="selectData"/>
					<PartInputBasic :data="InputBasicData"/>
					<PartInputSearch :data="InputSearchData"/>
					<PartInputTextarea :data="InputTextareaData"/>
					<PartCheckboxList :data="CheckboxListData"/>
					<PartInputTags :data="InputTagsData"/>
					<PartInputRange :data="InputRange"/>
					<PartCheckboxDropdown :data="CheckboxDropdown"/>
					<!-- <BlockTable :data="tableData"/> -->
					<BlockTable :data="tablePropertiesData"/>
					<BlockTable :data="tableEmailedData" @showPopupNoteEmail="showPopupNoteEmail" class="small-table"/>
					<BlockTable :data="tableClarificationData"/>
					<BlockTable :data="tableCheckboxData" class="checkbox-table"/>
					<BlockTable :data="tableLeadDashboardData"/>
					<BlockCustomTable :data="customTable"/>
					<PartColorPicker :data="colorPickerData" class="colorpicker"/>
					<PartColorPickerDate :data="ColorPickerDateData" class="colorpicker"/>
					<BlockMap :data="mapData"/>
					<BlockFloorRepeater :data="DataFloor"/>
					<BlockAccordion :data="accordionData"/>
					<BlockAccordion :data="accordionSecondData"/>
					<PartInput :data="autocompleteInput"/>
					<BlockBasic :data="basicData"/>

					<BlockPopupDetails @closePopupForm="closePopupForm" @showPopupNoteEmail="showPopupNoteEmail" :class="{'activeNoteEmail' : activeNoteEmail}" class="popups-content" :data="NoteEmailedData"/>
				</div>
			</main>
			<PartBackToTop/>
		</div>
</template>

<script>
import MainHeader from '@/components/main/MainHeader.vue';
import BlockBanner from '@/components/blocks/BlockBanner';
import BlockFloorRepeater from '@/components/blocks/BlockFloorRepeater';
import PartInputBasic from '@/components/parts/PartInputBasic';
import PartInputTextarea from '@/components/parts/PartInputTextarea';
import PartCheckboxList from '@/components/parts/PartCheckboxList';
import PartInputTags from '@/components/parts/PartInputTags';
import PartInputRange from '@/components/parts/PartInputRange';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import BlockBasic from '@/components/blocks/BlockBasic';
import PartInputSearch from '@/components/parts/PartInputSearch';
import { getDemoAsset } from '@/config/util';
import BlockTable from '@/components/blocks/BlockTable';
import PartColorPicker from '@/components/parts/PartColorPicker';
import PartSelect from '@/components/parts/PartSelect';
import BlockMap from '@/components/blocks/BlockMap';
import BlockAccordion from '@/components/blocks/BlockAccordion';
import PartColorPickerDate from '@/components/parts/PartColorPickerDate';
import PartBackToTop from '@/components/parts/PartBackToTop';
import BlockPopupDetails from '@/components/blocks/BlockPopupDetails';
import PartNoResults from '@/components/parts/PartNoResults';
import PartInput from '@/components/parts/PartInput';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import BlockCustomTable from '@/components/blocks/BlockCustomTable';

export default {

	components: {
		PartLoaderBig,
		BlockCustomTable,
		PartInput,
		PartNoResults,
		PartBackToTop,
		PartColorPickerDate,
		BlockAccordion,
		MainHeader,
		BlockBanner,
		BlockBasic,
		PartInputBasic,
		PartInputTextarea,
		PartCheckboxList,
		PartInputTags,
		PartInputRange,
		PartCheckboxDropdown,
		BlockTable,
		PartColorPicker,
		PartInputSearch,
		PartSelect,
		BlockMap,
		BlockPopupDetails,
		BlockFloorRepeater
	},

	data () {
		return {
			DataFloor: {},
			customTable: {},
			LoaderBigData: {},
			autocompleteInput: {
				label: 'Autocomplete:',
				value: [String, Number],
				textarea: Boolean,
				id: '',
				name: '',
				minlength: 6,
				type: 'text',
				placeholder: 'Type...'
			},
			activeNoteEmail: false,
			DataNoResults: {},
			NoteEmailedData: {
				popupDetailsTitle: 'Notes',
				items: [
					{
						hex: '#8BC34A',
						date: '10/02/2020',
						name: 'Emailed',
						label: 'Emailed note:',
						info: 'Does not buy coupon cutters....'
					},
					{
						hex: '#A564D8',
						date: '10/04/2020',
						name: 'Offer/negotiations'
					},
					{
						hex: '#009688',
						name: 'Phone call',
						date: '10/10/2020',
						label: 'Phone Call Note:',
						info: 'Some other comment....'
					},
					{
						hex: '#607D8B',
						name: 'Declined by customer',
						date: '10/06/2020'
					},
					{
						hex: '#000000',
						name: 'Appointment scheduled',
						date: '10/12/2020',
						label: 'Date:',
						info: '10/12/2020',
						classItem: 'item-veritical'
					}
				]
			},
			PropertiesListingData: {},
			accordionSecondData: {
				buttonName: 'Negotiating',
				// This class changes depending on which color is needed, all offered colors are in the helpers file
				buttonNameColor: 'accordion-mint',
				userNum: '5 Users',
				DataAccordionTable: {
					stickyHeader: true,
					noCollapse: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'name', label: 'Name', sortable: true, stickyColumn: true, variant: 'name' },
						{ key: 'offering_type', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'service-type' },
						{ key: 'area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						{ key: 'critical_notes', label: 'Area', sortable: true, stickyColumn: true, variant: 'critical-notes' },
						{ key: 'Type', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
						{ key: 'Building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
						{ key: 'Lot_size', label: 'Lot Size', sortable: true, stickyColumn: true, variant: 'lot-size' },
						{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'btn', label: '', sortable: false, stickyColumn: true, variant: 'email-btn' }
					],
					items: [

					]
				}
			},
			accordionData: {
				buttonName: 'Matches',
				// This class changes depending on which color is needed, all offered colors are in the helpers file
				buttonNameColor: 'accordion-orange',
				userNum: '3 Properties',
				DataAccordionTable: {
					stickyHeader: true,
					noCollapse: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'name', label: 'Name', sortable: true, stickyColumn: true, variant: 'name' },
						{ key: 'offering_type', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'service-type' },
						{ key: 'area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						{ key: 'critical_notes', label: 'Area', sortable: true, stickyColumn: true, variant: 'critical-notes' },
						{ key: 'Type', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
						{ key: 'Building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
						{ key: 'Lot_size', label: 'Lot size', sortable: true, stickyColumn: true, variant: 'lot-size' },
						{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'btn', label: '', sortable: false, stickyColumn: true, variant: 'email-btn' }
					],
					items: [

					]
				}
			},
			mapData: {

			},
			selectData: {
				label: 'Listing Status',
				placeholder: 'Status is here',
				options: [{
					id: 'Available',
					label: 'Available'
				}, {
					id: ' InContract',
					label: ' In Contract'
				}]
			},
			page: 'home',
			bannerData: {
				bigTitle: 'Section title',
				smTitle: 'Section title small',
				title: 'Banner Title',
				text: 'Here goes description paragraph',
				image: {
					sourceUrlDesk: getDemoAsset('property/property02.png'),
					sourceUrlTab: getDemoAsset('banner-dog-tab.jpg'),
					sourceUrlMob: getDemoAsset('banner-dog-mob.jpg')
				},
				scrollTo: {
					button: 'Scroll To',
					id: 'section-1'
				}
			},
			customersTableData: {

			},
			basicData: {
				sectionId: 'section-1',
				content: `
                        <h1>Heading 1</h1>

                        <h2>Paragraphs</h2>

                        <p><strong>Paragraph 1:</strong> Donec sed odio dui. Cras justo odio, dapibus ac facilisis in. Egestas eget quam. Maecenas faucibus mollis interdum maecenas faucibus. Cras mattis consectetur purus sit amet.</p>

                        <p><strong>Paragraph 2:</strong> Donec sed odio dui. Cras justo odio, dapibus ac facilisis in. Egestas eget quam. Maecenas faucibus mollis interdum maecenas faucibus. Cras mattis consectetur purus sit amet. <a href="#">Read more!</a></p>

                        <h3>Blockquote</h3>

                        <blockquote cite="#">
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusantium accusamus unde, necessitatibus quod reprehenderit, soluta quaerat voluptates vel obcaecati aut molestiae in. Illo dolores ut dignissimos? Placeat, laboriosam voluptatum? Exercitationem.
                        </blockquote>

                        <h3>Table</h3>

                        <table>
                            <tbody>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Savings</th>
                                </tr>
                                <tr>
                                    <td>Peter</td>
                                    <td>Griffin</td>
                                    <td>$100</td>
                                </tr>
                                <tr>
                                    <td>Lois</td>
                                    <td>Griffin</td>
                                    <td>$150</td>
                                </tr>
                                <tr>
                                    <td>Joe</td>
                                    <td>Swanson</td>
                                    <td>$300</td>
                                </tr>
                            </tbody>
                        </table>

                        <h3>Image</h3>

                        <figure class="wp-caption alignnone">
                            <a href="${getDemoAsset('dog-office.jpg')}">
                                <img class="wp-image-1 size-full" src="${getDemoAsset('dog-office-md.jpg')}" alt="">
                            </a>

                            <figcaption class="wp-caption-text">Greatness Awaits!</figcaption>
                        </figure>

                        <h3>Lists</h3>

                        <h4>Unordered list</h4>

                        <ul>
                            <li>Bread</li>
                            <li>Coffee beans</li>
                            <li>Milk</li>
                            <li>Butter</li>
                        </ul>

                        <h4>Ordered list</h4>

                        <ol>
                            <li>Coffee</li>
                            <li>Tea</li>
                            <li>Milk</li>
                        </ol>
                    `
			},
			ColorPickerDateData: {
				statusName: 'Lead',
				class: 'amaranth-color',
				colors: [
					{
						hex: '#FF9800',
						name: 'Lead',
						date: '10/02/2020'
					}, {
						hex: '#8BC34A',
						name: 'Emailed',
						date: '10/02/2020'
					}, {
						hex: '#009688',
						name: 'Phone call',
						date: '10/02/2020'
					}, {
						hex: '#E91E63',
						name: 'Appointment to show',
						date: '10/02/2020'
					}
				]
			},
			colorPickerData: {
				statusName: 'Lead',
				class: 'orange-color',
				colors: [
					{
						hex: '#FF9800',
						name: 'Lead'
					},
					{
						hex: '#8BC34A',
						name: 'Emailed'
					},
					{
						hex: '#009688',
						name: 'Phone call'
					},
					{
						hex: '#E91E63',
						name: 'Appointment to show'
					},
					{
						hex: '#000000',
						name: 'Appointment scheduled'
					},
					{
						hex: '#00BCD4',
						name: 'Follow up'
					},
					{
						hex: '#A564D8',
						name: 'Offer / negotiations'
					},
					{
						hex: '#4054B2',
						name: 'Lawyers'
					},
					{
						hex: '#795548',
						name: 'In contact'
					},
					{
						hex: '#9E9E9E',
						name: 'Closed'
					},
					{
						hex: '#607D8B',
						name: 'Declined by customer'
					},
					{
						hex: '#42526E',
						name: 'Dismissed system match'
					},
					{
						hex: '#2684FF',
						name: 'No follow up'
					}
				]
			},
			InputBasicData: {
				label: 'Name:',
				value: [String, Number],
				textarea: Boolean,
				id: '',
				name: '',
				minlength: 6,
				type: 'search',
				placeholder: 'Type in your password'
			},
			InputSearchData: {
				label: 'Property Name',
				value: [String, Number],
				textarea: Boolean,
				id: '',
				name: '',
				minlength: 6,
				type: 'text',
				placeholder: 'Search customers...'
			},
			InputTextareaData: {
				label: 'Your Note',
				placeholder: ''
			},
			CheckboxListData: {
				label: 'Listing status:',
				items: [
					{
						for: 'purchase',
						id: 'purchase',
						name: 'In contract',
						checked: false,
						type: 'checkbox'
					},
					{
						for: 'lease',
						id: 'lease',
						name: 'Available',
						checked: false,
						value: 'Lease',
						type: 'checkbox'
					}
				]
			},
			InputTagsData: {
				label: 'Keywords',
				placeholder: 'Add any keyword....'
			},
			InputRange: {
				iconName: ''
			},
			CheckboxDropdown: {
				placeholder: 'Any',
				label: 'Area',
				options: [{
					id: 'NewYork',
					label: 'New York',
					children: [{
						id: 'Brooklyn',
						label: 'Brooklyn',
						isNew: true,
						children: [{
							id: 'NearBoroPark',
							label: 'Near Boro Park',
							isNew: true
						}]
					}, {
						id: 'Queens',
						label: 'Queens'
					}, {
						id: 'Bronx',
						label: 'Bronx'
					}, {
						id: 'Manhattan',
						label: 'Manhattan'
					}, {
						id: 'StatenIsland',
						label: 'Staten Island'
					}, {
						id: 'LongIsland',
						label: 'Long Island'
					}, {
						id: 'WestchesterIsland',
						label: 'Westchester Island'
					}]
				}, {
					id: 'New Jersey',
					label: 'New Jersey',
					children: [{
						id: 'Near Brooklyn',
						label: 'Near Brooklyn'
					}]
				}, {
					id: 'Other',
					label: 'Other'
				}]
			},
			tablePropertiesData: {
				stickyHeader: true,
				noCollapse: false,
				tableClass: '',
				fields: [
					{ key: 'Property', label: 'Property', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'Stage', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
					{ key: 'Families', label: 'Families', sortable: true, stickyColumn: true, variant: 'families' },
					{ key: 'Source', label: 'Source', sortable: true, stickyColumn: true, variant: 'source' },
					{ key: 'Property_type', label: 'Property Type', sortable: true, stickyColumn: true, variant: 'property-type' },
					{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'Property_Shark_link', label: 'Property Shark Link', sortable: false, stickyColumn: true, variant: 'property-shark-link' },
					{ key: 'Date', label: 'Date', sortable: true, stickyColumn: true, variant: 'date' },
					{ key: 'btn', label: '', sortable: false, stickyColumn: true, variant: 'email-btn' }
				],
				items: [
					{
						Property: '454 Livonia ave (four lots)...',
						idProperty: 'property-01',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '5 Family',
						Source: 'Owns Staten Iland Warel',
						Property_type: 'Retail',
						Price: '$50,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '10/02/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property01.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							},
							{
								hex: '#009688',
								name: 'Phone call'
							},
							{
								hex: '#E91E63',
								name: 'Appointment to show'
							},
							{
								hex: '#000000',
								name: 'Appointment scheduled'
							},
							{
								hex: '#00BCD4',
								name: 'Follow up'
							},
							{
								hex: '#A564D8',
								name: 'Offer / negotiations'
							},
							{
								hex: '#4054B2',
								name: 'Lawyers'
							},
							{
								hex: '#795548',
								name: 'In contact'
							},
							{
								hex: '#9E9E9E',
								name: 'Closed'
							},
							{
								hex: '#607D8B',
								name: 'Declined by customer'
							},
							{
								hex: '#42526E',
								name: 'Dismissed system match'
							},
							{
								hex: '#2684FF',
								name: 'No follow up'
							}
						]
					},
					{
						Property: '454 Livonia ave ',
						idProperty: 'property-02',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '1 Family',
						Source: 'Owns Staten Iland Warel',
						Property_type: 'Retail',
						Price: '$500,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '10/02/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							},
							{
								hex: '#009688',
								name: 'Phone call'
							},
							{
								hex: '#E91E63',
								name: 'Appointment to show'
							},
							{
								hex: '#000000',
								name: 'Appointment scheduled'
							},
							{
								hex: '#00BCD4',
								name: 'Follow up'
							},
							{
								hex: '#A564D8',
								name: 'Offer / negotiations'
							},
							{
								hex: '#4054B2',
								name: 'Lawyers'
							}
						]
					},
					{
						Property: '454 Livonia ave (four lots)...',
						idProperty: 'property-01',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '5 Family',
						Source: 'Owns Staten Iland Warel',
						Property_type: 'Retail',
						Price: '$50,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '10/02/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property01.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							},
							{
								hex: '#009688',
								name: 'Phone call'
							},
							{
								hex: '#E91E63',
								name: 'Appointment to show'
							},
							{
								hex: '#000000',
								name: 'Appointment scheduled'
							},
							{
								hex: '#00BCD4',
								name: 'Follow up'
							},
							{
								hex: '#A564D8',
								name: 'Offer / negotiations'
							},
							{
								hex: '#4054B2',
								name: 'Lawyers'
							},
							{
								hex: '#795548',
								name: 'In contact'
							},
							{
								hex: '#9E9E9E',
								name: 'Closed'
							},
							{
								hex: '#607D8B',
								name: 'Declined by customer'
							},
							{
								hex: '#42526E',
								name: 'Dismissed system match'
							},
							{
								hex: '#2684FF',
								name: 'No follow up'
							}
						]
					},
					{
						Property: '454 Livonia ave ',
						idProperty: 'property-02',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '1 Family',
						Source: 'Owns Staten Iland Warel',
						Property_type: 'Retail',
						Price: '$500,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '10/02/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							},
							{
								hex: '#009688',
								name: 'Phone call'
							},
							{
								hex: '#E91E63',
								name: 'Appointment to show'
							},
							{
								hex: '#000000',
								name: 'Appointment scheduled'
							},
							{
								hex: '#00BCD4',
								name: 'Follow up'
							},
							{
								hex: '#A564D8',
								name: 'Offer / negotiations'
							},
							{
								hex: '#4054B2',
								name: 'Lawyers'
							}
						]
					},
					{
						Property: '766 Jamaica Ave Garden',
						idProperty: 'property-03',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '1 Family',
						Source: 'Owns Staten Iland Warel',
						Property_type: 'Sale',
						Price: '$60,000',
						Property_Shark_link: 'somelinkoftest.com',
						Date: '10/03/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Property: '66 Jamaica Ave',
						idProperty: 'property-04',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '10 Family',
						Source: 'Warel',
						Property_type: 'Retail',
						Price: '$90,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '16/05/2020',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property03.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Property: '9 Jamaica Ave',
						idProperty: 'property-05',
						// property href
						hrefProperty: '#',
						Stage: 'Lead',
						Families: '7 Family',
						Source: 'Iland Warel',
						Property_type: 'Retail',
						Price: '$550,000',
						Property_Shark_link: 'somelinkofpropert.com',
						Date: '05/02/2021',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'orange-color',
						isActive: true,
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					}
				]
			},
			tableEmailedData: {
				stickyHeader: true,
				noCollapse: false,
				tableClass: '',
				fields: [
					{ key: 'Property', label: 'Property', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'StagePopup', label: 'Stage', sortable: false, stickyColumn: false, variant: 'stage' },
					{ key: 'Source', label: 'Source', sortable: true, stickyColumn: true, variant: 'source' },
					{ key: 'Property_type', label: 'Property Type', sortable: true, stickyColumn: true, variant: 'property-type' },
					{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'Property_Shark_link', label: 'Property Shark Link', sortable: false, stickyColumn: true, variant: 'property-shark-link' },
					{ key: 'date_icon', label: 'Date', sortable: true, stickyColumn: false, variant: 'date-icon' },
					{ key: 'delete', label: '', sortable: false, stickyColumn: true, variant: 'delete' }
				],
				items: [
					{
						isActive: false,
						Property: '454-565 Livonia ave',
						idProperty: 'property-01',
						// property href
						hrefProperty: '#',
						StagePopup: 'Emailed',
						StagePopupIcon: 'ico-exclamation-mark',
						Source: 'Iland Warel',
						Property_type: 'Retail',
						Price: '$510,000',
						Property_Shark_link: 'fpropert.com',
						date_icon: '11/07/2021',
						delete: 'ico-delete',
						exclamanationMark: 'ico-exclamation-mark',
						idEmail: '',
						imgUrl: getDemoAsset('property/property01.png'),
						class: 'green-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#4054B2',
								name: 'Lawyers'
							},
							{
								hex: '#795548',
								name: 'In contact'
							},
							{
								hex: '#9E9E9E',
								name: 'Closed'
							},
							{
								hex: '#607D8B',
								name: 'Declined by customer'
							},
							{
								hex: '#42526E',
								name: 'Dismissed system match'
							},
							{
								hex: '#2684FF',
								name: 'No follow up'
							}
						]
					},
					{
						isActive: false,
						Property: '44 Livonia ave ',
						idProperty: 'property-02',
						// property href
						hrefProperty: '#',
						StagePopup: 'Emailed',
						StagePopupIcon: 'ico-exclamation-mark',
						Families: '4 Family',
						Source: 'Owns Staten',
						Property_type: 'Retail',
						Price: '$30,000',
						Property_Shark_link: 'somefpropert.com',
						date_icon: '09/02/2020',
						delete: 'ico-delete',
						exclamanationMark: 'ico-exclamation-mark',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'green-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#000000',
								name: 'Appointment scheduled'
							},
							{
								hex: '#00BCD4',
								name: 'Follow up'
							},
							{
								hex: '#A564D8',
								name: 'Offer / negotiations'
							},
							{
								hex: '#4054B2',
								name: 'Lawyers'
							}
						]
					},
					{
						isActive: false,
						Property: '6 Ave Garden',
						idProperty: 'property-03',
						// property href
						hrefProperty: '#',
						StagePopup: 'Emailed',
						StagePopupIcon: 'ico-exclamation-mark',
						Families: '3 Family',
						Source: 'Owns Iland Warel',
						Property_type: 'Retail',
						Price: '$90,000',
						Property_Shark_link: 'somelinkofpropert.com',
						DateIcon: '10/07/2020',
						delete: 'ico-delete',
						exclamanationMark: 'ico-exclamation-mark',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'green-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						isActive: false,
						Property: '10 Jamaica Ave',
						idProperty: 'property-04',
						// property href
						hrefProperty: '#',
						StagePopup: 'Emailed',
						StagePopupIcon: 'ico-exclamation-mark',
						Families: '2 Family',
						Source: 'Iland Warel',
						Property_type: 'Retail',
						Price: '$70,000',
						Property_Shark_link: 'somelinkofpropert.com',
						DateIcon: '11/02/2020',
						delete: 'ico-delete',
						exclamanationMark: 'ico-exclamation-mark',
						idEmail: '',
						imgUrl: getDemoAsset('property/property03.png'),
						// This class it should be added to idem if it is a disabled row
						class: 'invalid-stage',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						isActive: false,
						Property: '9 Jamaica Ave',
						idProperty: 'property-05',
						// property href
						hrefProperty: '#',
						StagePopup: 'Emailed',
						StagePopupIcon: 'ico-exclamation-mark',
						Families: '5 Family',
						Source: 'Owns Warel',
						Property_type: 'Retail',
						Price: '$8,000',
						Property_Shark_link: 'somelinkofpropert.com',
						date_icon: '22/02/2020',
						delete: 'ico-delete',
						exclamanationMark: 'ico-exclamation-mark',
						idEmail: '',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'green-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					}
				]
			},
			tableClarificationData: {
				stickyHeader: true,
				noCollapse: false,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'Property', label: 'Name', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'Stage', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
					{ key: 'offering_type', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'service-type' },
					{ key: 'Area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
					{ key: 'Type', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'Building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'Lot_size', label: 'Lot size', sortable: true, stickyColumn: true, variant: 'lot-size' },
					{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					// { key: 'Price_per', label: 'Price per sf', sortable: true, stickyColumn: true, variant: 'price-per' },
					{ key: 'Listing_status', label: 'Listing Status', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'Test', label: 'Test', sortable: false, stickyColumn: true },
					{ key: 'Test_01', label: 'Test 01', sortable: false, stickyColumn: true },
					/* this must always be the last */
					{ key: 'icon', label: '', sortable: false, stickyColumn: true, variant: 'fixed-col icon' }
				],
				items: [
					{
						id: 1,
						offering_type: 'Sale',
						Property: '76 Jamaica Ave',
						idName: 'name-01',
						// property href
						hrefProperty: '#',
						Stage: '5 Needs clarification',
						Area: 'New York',
						Type: 'House',
						Building_size: '20-50m2',
						Lot_size: '10-50m2',
						Price: '$100,000',
						Price_per: '$80,000',
						Listing_status: 'Available',
						icon: '',
						idIconName: 'icon-name-01',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'purple-color',
						Test: 'test',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						offering_type: 'Lease',
						Property: '454-505 Livonia ave',
						idName: 'name-02',
						// property href
						hrefProperty: '#',
						Stage: '1 Needs clarification',
						Area: 'New York',
						Type: 'House, building',
						Building_size: '40-90m2',
						Lot_size: '30-60m2',
						Price: '$500,000',
						Price_per: '$500,000',
						icon: '',
						idIconName: 'icon-name-02',
						Listing_status: 'Available',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'purple-color',
						Test: 'test',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						offering_type: 'Purchase',
						Property: '5 Jamaica Ave',
						idName: 'name-03',
						// property href
						hrefProperty: '#',
						Stage: '8 Needs clarification',
						Area: 'Brooklyn',
						Type: 'Building',
						Building_size: '60-70m2',
						Lot_size: '10-45m2',
						Price: '$700,000',
						Price_per: '$90,000',
						Listing_status: 'Available',
						icon: '',
						idIconName: 'icon-name-03',
						imgUrl: getDemoAsset('property/property02.png'),
						class: 'purple-color',
						Test_01: 'tafdd',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					}
				]
			},
			tableCheckboxData: {
				stickyHeader: true,
				noCollapse: false,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'selected', label: 'Name', sortable: true, stickyColumn: true, variant: 'select-all' },
					{ key: 'StagePopup', label: 'Stage', sortable: false, stickyColumn: false, variant: 'stage' },
					{ key: 'Source', label: 'Source', sortable: true, stickyColumn: true, variant: 'source' },
					{ key: 'Property_type', label: 'Property type', sortable: true, stickyColumn: true, variant: 'property-type' },
					{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'Note', label: 'Note', sortable: true, stickyColumn: true, variant: 'note' },
					{ key: 'Phone', label: 'Phone', sortable: true, stickyColumn: true, variant: 'phone' },
					{ key: 'Date', label: 'Date', sortable: true, stickyColumn: true, variant: 'date' },
					{ key: 'btn', label: '', sortable: false, stickyColumn: true, variant: 'email-btn' }
				],
				items: [
					{
						Name: 'Paul Castal',
						nameId: 'name-01',
						StagePopup: 'Lead',
						Source: 'Iland Warel',
						Property_type: '2 Family, 2-5 Family',
						Price: '$50,000 - $100,000',
						Note: 'Does not buy coupon cutTest....',
						Phone: '435-769-4776',
						Date: '11.12.2021.',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						class: 'orange-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Kamran Griffith',
						nameId: 'name-02',
						StagePopup: 'Lead',
						Source: 'Owns Staten Iland Warel',
						Property_type: '1 Family, 4-6 Family',
						Price: '$500,000 - $1,500,000',
						Note: 'Does not buy coupon cutTest....',
						Phone: '425-702-4726',
						Date: '10.02.2020.',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						class: 'orange-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Miah Olson',
						nameId: 'name-03',
						StagePopup: 'Lead',
						Source: 'Owns Iland',
						Property_type: '3 Family, 4-6 Family',
						Price: '$600,000 - $1,700,000',
						Note: '-',
						Phone: '437-703-4717',
						Date: '11.02.2020.',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						class: 'orange-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Ana Griffith',
						nameId: 'name-04',
						StagePopup: 'Lead',
						Source: 'Iland',
						Property_type: '2 Family, 4-5 Family',
						Price: '$700,000 - $1,900,000',
						Note: 'Does not buy coupon cutTest....',
						Phone: '415-111-4736',
						Date: '18.06.2020.',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						class: 'orange-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Jon Olson',
						nameId: 'name-05',
						StagePopup: 'Lead',
						Source: 'Owns Staten Iland Warel',
						Property_type: '1 Family',
						Price: '$300,000 - $2,500,000',
						Note: '-',
						Phone: '435-703-5555',
						Date: '10.12.2020.',
						btn: 'Send email',
						// email link href
						hrefEmail: '#',
						class: 'orange-color',
						popupTitle: 'Notes',
						popupLabel: 'Emailed note:',
						popupContent: 'Does not buy coupon cutters....',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					}
				]
			},
			tableLeadDashboardData: {
				stickyHeader: true,
				noCollapse: false,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'Name', label: 'Name', sortable: true, stickyColumn: true, variant: 'name' },
					{ key: 'Stage', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
					{ key: 'Source', label: 'Source', sortable: true, stickyColumn: true, variant: 'source' },
					{ key: 'Property_type', label: 'Property type', sortable: true, stickyColumn: true, variant: 'property-type' },
					{ key: 'Price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'Note', label: 'Note', sortable: true, stickyColumn: true, variant: 'note' },
					{ key: 'Phone', label: 'Phone', sortable: true, stickyColumn: true, variant: 'phone' },
					{ key: 'Email', label: 'Email', sortable: true, stickyColumn: true, variant: 'email' },
					/* this must always be the last */
					{ key: 'icon', label: '', sortable: false, stickyColumn: true, variant: 'fixed-col icon' }
				],
				items: [
					{
						Name: 'Ana Castalano',
						// property href
						hrefProperty: '#',
						idName: 'name-01',
						checkboxId: '01',
						Stage: '7 Matches',
						class: 'orange-color',
						Source: 'Iland Warel',
						Property_type: '2 Family, 3-4 Family',
						Price: '$1,000,000 - $1,800,000',
						Note: 'Does not buy coupon cut',
						Phone: '435-111-4736',
						Email: 'smithsonjon@gmail.com',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Maya Griffith',
						// property href
						hrefProperty: '#',
						idName: 'name-02',
						checkboxId: '02',
						Stage: '1 Matches',
						class: 'orange-color',
						Source: 'Warel',
						Property_type: '2 Family, 2-6 Family',
						Price: '$400,000 - $1,000,000',
						Note: 'Does not buy coupon cut',
						Phone: '111-703-4736',
						Email: 'smithjon@gmail.com',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Ben Olson',
						// property href
						hrefProperty: '#',
						idName: 'name-03',
						checkboxId: '03',
						Stage: '10 Matches',
						class: 'orange-color',
						Source: 'Owns Staten Iland Warel',
						Property_type: '4 Family, 4-6 Family',
						Price: '$560,000 - $1,200,000',
						Note: '-',
						Phone: '435-113-1136',
						Email: '',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Rikesh Samuels',
						// property href
						hrefProperty: '#',
						checkboxId: '04',
						idName: 'name-04',
						Stage: '9 Matches',
						class: 'orange-color',
						Source: 'Staten Iland Warel',
						Property_type: '1 Family, 2-9 Family',
						Price: '$600,000 - $3,500,000',
						Note: 'Does not buy coupon cut',
						Phone: '999-703-4736',
						Email: 'smithsonte@gmail.com',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					},
					{
						Name: 'Katie O ’Sullivan',
						// property href
						hrefProperty: '#',
						checkboxId: '05',
						idName: 'name-03',
						Stage: '8 Matches',
						class: 'orange-color',
						Source: 'Iland Warel',
						Property_type: '5 Family, 2-3 Family',
						Price: '$900,000 - $1,900,000',
						Note: '-',
						Phone: '435-703-6666',
						Email: 'smithsonana@gmail.com',
						colors: [
							{
								hex: '#FF9800',
								name: 'Lead'
							},
							{
								hex: '#8BC34A',
								name: 'Emailed'
							}
						]
					}
				]
			}
		};
	},
	methods: {
		closePopupForm() {
			this.activeNoteEmail = false;
		},
		showPopupNoteEmail() {
			this.activeNoteEmail = !this.activeNoteEmail;
		}
	}
};
</script>
<style lang="scss" scoped>
.popups-content {
	visibility: hidden;
	backface-visibility: hidden;
	transition: $dur $ease;
	opacity: 0;

	&.activeNoteEmail {
		opacity: 1;
		transition: $dur $ease;
		visibility: visible;
	}
}
</style>
